import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectIsLoading = (store: StoreSchema) =>
	store.clientLabel.isLoading